<div class="bg-background-underground p-sm gap-sm flex flex-col rounded-md">
  <div class="gap-xs flex items-center">
    <div class="size-md text-components-content-primary-darker">
      <ng-icon class="text-components-content-primary-darker" name="lucideBadgeCheck" hlm size="sm" />
    </div>
    <span class="text-content-secondary component-small-semibold"
      >Certification : {{ etape().certification?.codeFiche ?? 'Non renseignée' }}</span
    >
  </div>
</div>
